import React, { ComponentType } from 'react'
import { ApolloProvider } from '@apollo/client'
import { clients } from '../../lib'

export default (Component: ComponentType) =>
  (props: object = {}) => {
    const { filter, query } = props

    if (filter && query === undefined) {
      return null
    }

    const browser = typeof window !== 'undefined' && window
    if (browser) {
      const client = window.location.host

      const localClient = clients[client] ? clients[client] : clients.default

      return (
        <ApolloProvider client={localClient}>
          <Component {...props} />
        </ApolloProvider>
      )
    }
    return null
  }
